export default {
  navBar: {
    project: "Project: {project}",
    disconnect: "Logout",
    language: {
      title: "Change language",
      en: "English",
      fr: "French",
    }
  },
  menu: {
    dashboard: "Dashboard",
    projects: "Projects",
    projectsSettings: "Settings",
    projectsUsers: "Users",
    projectsAgences: "Area",
    projectsLocalities: "Localities",
    forms: "Questionnaires",
    customers: "Clients",
    customerDoubles: "Duplicate clients",
    map: "Map",
    reporting: "Reporting",
    payments: "Payments",
    users: "Users",
    logs: "Logs",
    tables: "Database access",
    settings: "Settings",
    mapElligibility: "Map eligibility",
  },
}
